// extracted by mini-css-extract-plugin
export default {"link":"FO-z","disabled":"GO-z"};